/* eslint-disable react/no-children-prop */
import { Grid, Typography } from '@material-ui/core';
import { useRootTranslation } from 'utils/hooks';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import { Text } from 'components/styleguide';

const rootT = 'drawers.importTracksSpreadsheetDrawer.errorOnSpreadsheet';

const ErrorOnSpreadsheet = ({
  error,
  setReadyImport,
  setValidSpreadsheet,
}) => {
  const t = useRootTranslation(rootT);
  return (
    <Grid
      container
      xs={12}
      direction="column"
      justifyContent="center"
      alignContent="center"
      alignItems="center"
    >
      <Grid
        container
        direction="row"
        justifyContent="center"
        alignItems="center"
        spacing={1}
      >
        <ReportProblemIcon color="error" />
        <Text color="red" variant="formLabel" children={t('error')} bold />
      </Grid>
      <Grid item alignContent="center">
        <Text variant="formLabel" children={error} />
      </Grid>
      <Grid item>
        <div>
          <Typography
            variant="caption"
            style={{
              textDecoration: 'underline',
              color: 'primary.main',
              cursor: 'pointer',
            }}
            children={t('tryAgain')}
            onClick={() => {
              setReadyImport(null);
              setValidSpreadsheet({
                state: null,
                error: null,
              });
            }}
          />
        </div>
      </Grid>
    </Grid>
  );
};

export default ErrorOnSpreadsheet;
